import {createEnumType} from 'acscp/api/models/customTypes/enumUtils';

export enum TimeType {
    UTC = 'UTC',
    Local = 'Local',
}

export const TimeDynamicType =  createEnumType('TimeType', TimeType);
